import React, { useState, useRef, useEffect } from "react";
import styled, { css } from "styled-components";
import { rem } from "polished";
import Star from "../../assets/img/star-solid.svg";

const StarsWrap = styled.div`
	display: inline-block;
	margin-right: ${rem(8)};

	img {
		width: 13px;
		color: #cc6f4c;
	}
	svg {
		fill: #27ae60;
	}
`;
const Flex = styled.div`
	display: flex;
	margin-bottom: ${rem(15)};
`;

const Stars = (props) => {
	return (
		<Flex>
			<StarsWrap>
				<img src={Star} alt="" />
				<img src={Star} alt="" />
				<img src={Star} alt="" />
				<img src={Star} alt="" />
				<img src={Star} alt="" />
			</StarsWrap>
			{props.children}
		</Flex>
	);
};

export default Stars;
